import React from "react";
import "./styles/initchat.css";

export default function InitChat({ inAppCall, call, inAppMessaging }) {
  return (
    <>
      <div className="chat-btn">
        <button
          disabled={call.loading}
          onClick={inAppCall}
          className="call-btn projects-btn"
        >
          <span className="material-icons-outlined white-icon">
            {call.loading ? "hourglass_bottom" : "call"}
          </span>
        </button>
        <button
          onClick={inAppMessaging}
          disabled={call.loading}
          className="message-btn"
        >
          <span className="material-icons-outlined white-icon">message</span>
        </button>
      </div>

      <div className="chat-greeting">
        <svg width="100" height="100" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="10" fill="#00d4ff">
            <animate
              attributeName="r"
              from="10"
              to="12"
              dur="1s"
              repeatCount="indefinite"
            />
          </circle>
          <text x="12" y="18" textAnchor="middle" fill="#fff">
            Hi!
          </text>
        </svg>
        <div>
          <p>
            (Please Wait I will build n8n workflow for backend .i will add n8n
            in backend Start) a chat with the developer — OpenAI’s advanced
            models will respond to FAQs and provide possible live solutions,you
            can also book meeting with developer
          </p>
        </div>
      </div>
    </>
  );
}
